var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":_vm.placeholder},on:{"change":_vm.change},model:{value:(_vm.selVal),callback:function ($$v) {_vm.selVal=$$v},expression:"selVal"}},_vm._l((_vm.dicItems),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }